const fetchOptions = { credentials: 'same-origin' }
export default fetchOptions
